var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C20B1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_137_10",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 12,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3046 9.80945H14.6956V30.1904H25.3046V9.80945Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_137_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8146 30.1903C17.8146 30.0903 17.8076 29.9903 17.8076 29.8903C17.8076 27.015 17.8076 24.1393 17.8076 21.2633C17.8076 20.9343 17.8076 20.9343 17.4696 20.9343C16.6286 20.9343 15.7866 20.9343 14.9456 20.9343C14.7546 20.9343 14.6956 20.8743 14.6966 20.6833C14.7039 19.6273 14.7036 18.5693 14.6956 17.5093C14.6956 17.3003 14.7686 17.2533 14.9606 17.2553C15.8286 17.2633 16.6966 17.2553 17.5606 17.2633C17.7536 17.2633 17.8096 17.2043 17.8076 17.0143C17.7986 16.2453 17.7956 15.4773 17.8076 14.7083C17.7947 13.9585 17.9198 13.2128 18.1766 12.5083C18.4334 11.8211 18.8719 11.2164 19.4453 10.7587C20.0187 10.301 20.7055 10.0074 21.4326 9.9093C22.228 9.80266 23.0327 9.78221 23.8326 9.8483C24.2526 9.8573 24.6736 9.9093 25.0956 9.9363C25.2456 9.9453 25.3046 9.9913 25.3046 10.1483C25.2992 11.109 25.2992 12.0696 25.3046 13.0303C25.3046 13.1943 25.2366 13.2303 25.0906 13.2303C24.5906 13.2253 24.0836 13.2203 23.5796 13.2303C23.2832 13.2311 22.9874 13.2575 22.6956 13.3093C22.4155 13.344 22.1565 13.4763 21.9643 13.6829C21.7721 13.8896 21.6589 14.1574 21.6446 14.4393C21.5506 15.3303 21.6236 16.2263 21.6036 17.1193C21.6036 17.2753 21.7126 17.2573 21.8106 17.2573H24.3956C24.5876 17.2573 24.7806 17.2633 24.9716 17.2573C25.1396 17.2513 25.1866 17.3103 25.1636 17.4823C25.0176 18.557 24.8789 19.6323 24.7476 20.7083C24.7256 20.8883 24.6546 20.9403 24.4826 20.9393C23.6146 20.9333 22.7466 20.9393 21.8826 20.9393C21.6076 20.9393 21.6066 20.9393 21.6066 21.2093C21.6066 24.1046 21.6066 27 21.6066 29.8953C21.6066 29.9953 21.5996 30.0953 21.5956 30.1953L17.8146 30.1903Z",
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.e7b6ec956415b1348ff66bab53b3eb93.svg";
export { ForwardRef as ReactComponent };